import React from 'react';
import modalAction from '../actions/modalAction';
import modalStore from '../stores/modalStore';

class ModalGeneral extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.onChange = this.onChange.bind(this);
        this.state={
            title: modalStore.getState().title,
            content: modalStore.getState().content,
            modalClose: modalStore.getState().modalClose,
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };

    componentDidMount() {
        modalStore.listen(this.onChange);
    }
    componentWillUnmount() {
        modalStore.unlisten(this.onChange);
    }
    onChange(state){
        this.setState({
            title: state.title,
            content: state.content,
            modalClose: state.modalClose,
        });
    }    

    modalClose() {
        modalAction.modalClose(false);
    }
    render() {
        let style = this.state.modalClose ? this.props.styleShow : this.props.styleHide;
        
        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="report-modal" style={{ visibility: style.visibility }}>
                    <div className="modal-header">
                        <h4 className="modal-title">{this.state.title}</h4>
                    </div>

                    <div className="modal-body" >
                        {this.state.content}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default single-btn" onClick={this.modalClose}>Ok</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default ModalGeneral;


// WEBPACK FOOTER //
// ./app/components/modalGeneral.js